import { render, staticRenderFns } from "./NewMetadataCards.vue?vue&type=template&id=6f6cf0f6&scoped=true"
import script from "./NewMetadataCards.vue?vue&type=script&lang=js"
export * from "./NewMetadataCards.vue?vue&type=script&lang=js"
import style0 from "./NewMetadataCards.vue?vue&type=style&index=0&id=6f6cf0f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6cf0f6",
  null
  
)

export default component.exports